import type { AssetTypesSelectProps } from "./asset-types-select.type";

import { useTranslation } from "react-i18next";

import { AssetTypeSelect } from "@/modules/asset-type/asset-type-select";

export const AssetTypesSelect = (props: AssetTypesSelectProps) => {
  const { t } = useTranslation();

  return (
    <AssetTypeSelect
      mode="multiple"
      name="asset_types"
      label={t("global:assetTypePlural")}
      data-testid="asset-types-select"
      {...props}
    />
  );
};
